import { render, staticRenderFns } from "./OmnichannelStrategyPage.vue?vue&type=template&id=fcb249b8&scoped=true"
import script from "./OmnichannelStrategyPage.vue?vue&type=script&lang=ts"
export * from "./OmnichannelStrategyPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcb249b8",
  null
  
)

export default component.exports